/**
 * Return `true` if and only if `number` is a number.
 *
 * @param {number} number -
 * @return {boolean}
 */
export function isNumber(number) {
	return typeof number === "number" && !isNaN(number);
}

/**
 * Return `true` if and only if `number` is an integer.
 *
 * @param {number} number -
 * @return {boolean}
 */
export function isInteger(number) {
	return isNumber(number) && number % 1 === 0;
}

/**
 * Return `arg` if it is a number. If `arg` is a string and is
 * composed of digits, the corresponding number is returned.
 *
 * @param {number|string} arg -
 * @return {number}
 */
export function toNumber(arg) {
	return +arg;
}

/**
 * Return a number as close to `x` as possible and within
 * [`min`,`max`].
 *
 * More precisely:
 * - return `x` if `x` ∈ [min,max]
 * - return `min` if `x` < `min`
 * - return `max` if `x` > `max`.
 *
 * @param {number} x -
 * @param {number} min -
 * @param {number} max -
 * @return {number}
 */
export function clamp(x, min, max) {
	return Math.min(Math.max(x, min), max);
}

/**
 * Return the same value as what the remainder operator `%` would
 * return when `dividend` is positive. Return a number between 0 and
 * `divisor - 1` otherwise.
 *
 * @param {number} dividend -
 * @param {number} divisor -
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder} for a description of the differences between the modulo and the remainder.
 * @return {number}
 */
export function modulo(dividend, divisor) {
	return ((dividend % divisor) + divisor) % divisor;
}
